import { FILTER_PROFILE } from "../diccionary/Diccionary";

// TW Marketing solo entra a la sección Postulaciones, pero dentro de ella tiene
// acceso completo (todas las columnas, filtros, acciones y descargas). Lo único
// que no puede es gestionar formularios (crear / editar / activar-desactivar),
// y eso se controla con PROFILE_ADMIN_SEL en TablaFormularios.
const TW_MARKETING_PUBLIC_PATHS = ["/", "/login", "/router"];

export const isTwMarketingProfile = (profile: string | null | undefined): boolean =>
  profile === FILTER_PROFILE.tw_marketing;

// Operaciones y Contratos ven Postulaciones con las mismas reglas que TW
// Marketing (todo, salvo gestionar formularios). A diferencia de Marketing, no
// quedan limitados a esa sección.
export const POSTULACIONES_VIEWER_PROFILES: string[] = [
  FILTER_PROFILE.tw_marketing,
  FILTER_PROFILE.tw_ops,
  FILTER_PROFILE.tw_contrato,
];

export const isPostulacionesViewerProfile = (profile: string | null | undefined): boolean =>
  POSTULACIONES_VIEWER_PROFILES.includes(profile ?? "");

export const canTwMarketingAccessPath = (pathname: string): boolean =>
  pathname === "/postulaciones" || TW_MARKETING_PUBLIC_PATHS.includes(pathname);
